// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".c2a4c4da4b1d1779dc3a1718d81f0654.js";
};